import { render } from "./NotebookMenuSwitcher.vue?vue&type=template&id=2c0245d6"
import script from "./NotebookMenuSwitcher.vue?vue&type=script&lang=js"
export * from "./NotebookMenuSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "/root/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__